import React, { useState, useEffect } from 'react';
import Job from './Job';
import Title from './Title';
import JobInfo from './JobInfo';

const url = 'https://course-api.com/react-tabs-project';

function App() 
{
  const [loading, setLoading] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [value, setValue] = useState(0);

  const fetchJobs = async () => 
  {
    const reponse = await fetch(url);
    const newJobs = await reponse.json();
    setJobs(newJobs);
    setLoading(false);
  }
  
  useEffect(() => 
  {
    fetchJobs();
  }, [])
  
  if (loading) 
  {
    return (
      <section className="section loading">
        <h1>Loading...</h1>
      </section>);
  }

  return (
    <section className="section">
        <Title />
      <div className="jobs-center">
        {/* btn container */}
        <div className="btn-container">
          {
              jobs.map((job, index) => 
              {
                  return (<Job key = {job.id} {...job} index = {index} value = {value} setValue = {setValue} />);
              })
          }
        </div>
        {/* job info */}
        <JobInfo {...jobs[value]} />
      </div>
      <button type="button" className="btn">more info</button>
    </section>
  )
}

export default App
